module.exports = __webpack_public_path__ + "img/superior_imediato.95ea5430.png";